import { Country } from '../../enums';

const globalizedFaqs: Partial<Record<Country, { [key: string]: string }>> = {
  [Country.FR]: {
    premiumPlan: 'faq.why_do_i_need_premium.frpp',
    customDomain: 'faq.custom_domain.frpp',
    freeDomain: 'faq.free_domain.frpp',
    domainPurchasedElswhere: 'faq.domain_purchased_elsewhere.frpp',
    emailAddress: 'faq.personalized_email_address.frpp',
    searchEngines: 'faq.visible_search_engines.frpp',
    siteContentOwnership: 'faq.site_content_ownership.frpp',
    gdprCompilant: 'faq.gdpr_compliant.frpp',
    whereAreServersLocated: 'faq.where_are_servers_located.frpp',
    acceptOnlinePayment: 'faq.accepted_online_payments.frpp',
    cancelMyPlan: 'faq.cancel_my_plan.frpp',
    subscriptionCycle: 'faq.subscription_charge_cycle.frpp',
  },
  [Country.JA]: {
    premiumPlan: 'faq.premium_plan.japanpp',
    planDifferences: 'faq.plan_differences.japanpp',
    customDomain: 'faq.custom_domain.japanpp',
    customDomainsBenfits: 'faq.custom_domain_benefits.japanpp',
    personalizedEmailAddress: 'faq.personalized_email_address.japanpp',
    checkPaymentDetails: 'faq.check_payment_details.japanpp',
    paymentMethods: 'faq.payment_methods.japanpp',
  },
};

export const getSpecifiedCountryFaqs = ({ country }: { country: Country }) => {
  return globalizedFaqs[country]!;
};
